// API utility for making requests to the server

// Determine the base URL for API requests
// In development, use the local server with dynamic port detection
// In production, use the deployed server URL
const getBaseUrl = () => {
  if (import.meta.env.MODE === 'development') {
    // In development, use the local server directly
    return 'http://localhost:8080/api';
  } else {
    // In production, use the Railway backend URL
    return 'https://nostrie-production.up.railway.app/api';
  }
};

// API functions for fetching data
export const fetchPetState = async () => {
  try {
    const response = await fetch(`${getBaseUrl()}/pet-state`);
    if (!response.ok) {
      throw new Error(`API error: ${response.status}`);
    }
    return await response.json();
  } catch (error) {
    console.error('Error fetching pet state:', error);
    return null;
  }
};

// New function to fetch pet state data for the usePetState hook
export const fetchPetStateData = async () => {
  try {
    const data = await fetchPetState();
    
    // If the server didn't return a status field, add a default one
    if (!data.status) {
      data.status = { connected: true, message: null };
    }
    
    return data;
  } catch (error) {
    console.error('Error in fetchPetStateData:', error);
    throw error;
  }
};

export const fetchPetHistory = async () => {
  try {
    const response = await fetch(`${getBaseUrl()}/pet-history`);
    if (!response.ok) {
      throw new Error(`API error: ${response.status}`);
    }
    return await response.json();
  } catch (error) {
    console.error('Error fetching pet history:', error);
    // Return empty history array as fallback
    return [];
  }
};

export const fetchStats = async () => {
  try {
    const response = await fetch(`${getBaseUrl()}/stats`);
    if (!response.ok) {
      throw new Error(`API error: ${response.status}`);
    }
    return await response.json();
  } catch (error) {
    console.error('Error fetching stats:', error);
    return null;
  }
};

// New function to fetch live events
export const fetchLiveEvents = async () => {
  try {
    const response = await fetch(`${getBaseUrl()}/live-events`);
    if (!response.ok) {
      throw new Error(`API error: ${response.status}`);
    }
    return await response.json();
  } catch (error) {
    console.error('Error fetching live events:', error);
    return [];
  }
}; 